import request from '@/http/request'
import wayCode from "@/utils/wayCode"
import channelUserIdUtil from "@/utils/channelUserId";
import config from '@/config'

/** 获取url **/
export function getRedirectUrl() {
	return request.request({
		url: '/api/cashier/redirectUrl',
		method: 'POST',
		data: {
			wayCode: wayCode.getPayWay().wayCode,
			token: config.cacheToken
		}
	})
}

/** 获取url **/
export function getPayRedirectUrl() {
	return request.request({
		url: '/api/cashier/payRedirectUrl',
		method: 'POST',
		data: {
			wayCode: wayCode.getPayWay().wayCode,
			token: config.cacheToken
		}
	})
}

/** 获取url **/
export function getQrcPayRedirectUrl() {
	return request.request({
		url: '/api/cashier/redirectUrl',
		method: 'POST',
		data: {
			wayCode: wayCode.getPayWay().wayCode,
			token: config.cacheToken,
			qrcType: config.qrcType.QRC_STATIC.code
		}
	})
}

/** 扫码支付 **/
export function cashierPayOrder() {
	return request.request({
		url: '/api/cashier/cashierPayOrder',
		method: 'POST',
		data: {
			wayCode: wayCode.getPayWay().wayCode,
			token: config.cacheToken,
			qrcType: config.qrcType.QRC_STATIC.code
		}
	})
}
/** 扫码 跳转至商铺首页  类似于扫码小程序二维码 **/
export function identifyUserToLite() {
	return request.request({
		url: '/api/cashier/identifyUserToLite',
		method: 'POST',
		data: {
			wayCode: wayCode.getPayWay().wayCode,
			token: config.cacheToken,
			qrcType: config.qrcType.QRC_STATIC.code
		}
	})
}

/** 获取url **/
export function getChannelUserId(redirectData) {
	return request.request({
		url: '/api/cashier/channelUserId',
		method: 'POST',
		data: Object.assign({
			wayCode: wayCode.getPayWay().wayCode,
			token: config.cacheToken
		}, redirectData)
	})
}

/** 调起支付接口, 获取支付数据包 **/
export function getPayPackage(amount, remark) {
	return request.request({
		url: '/api/cashier/pay',
		method: 'POST',
		data: {
			wayCode: wayCode.getPayWay().wayCode,
			token: config.cacheToken,
			amount: amount,
			buyerRemark: remark,
			channelUserId: channelUserIdUtil.getChannelUserId()
		}
	})
}

/** 调起支付接口, 获取订单信息 **/
export function getPayOrderInfo() {
	return request.request({
		url: '/api/cashier/payOrderInfo',
		method: 'POST',
		data: {
			token: config.cacheToken
		}
	})
}

/** 取消订单 **/
export function cancelPay() {
	return request.request({
		url: '/api/cashier/cancelPay',
		method: 'POST',
		data: {
			token: config.cacheToken
		}
	})
}